import { Badge, Button, CircularProgress, Grid2, IconButton, Typography } from '@mui/material'
import Container from '../../../components/Container'
import { FilterFrames, Login, Person } from '@mui/icons-material'
import LangDropdown from '../../../components/LangDropdown'
import { Outlet, useNavigate } from 'react-router-dom'
import sierraBackground from '/sierra-background.png'
import { useAuth } from '../../../hooks/useAuth'
import { memo, useCallback, useEffect, useRef, useState } from 'react'
import ChatFab from '../Chat/ChatFab'
import { IOrder, IOrderSocketResponse } from 'sierra'
import api from '../../../utils/axios'
import socket from '../../../utils/socket'
import { version } from '../../../../package.json'
import { useApp } from '../../../contexts/AppContext'

const Layout = memo(() => {
    const navigate = useNavigate()
    const { translate, screenSize } = useApp()

    const { user, fetchUser, userLoaded } = useAuth()
    const [orders, setOrders] = useState<Required<IOrder>[]>()

    const ordersRef = useRef(orders);

    const fetchOrders = () => {
        api.get('/orders', { params: { exclude_fields: 'service_form,branch' } }).then(({ data }) => setOrders(data)).catch(console.error)
    }

    useEffect(() => {
        fetchUser()
    }, [])

    const handleOrdersListener = useCallback((data: IOrderSocketResponse[]) => {
        if (!ordersRef.current) return
        const changedOrderIds = data.map(order => order.order_id);
        const shouldFetch = ordersRef.current.some(order => changedOrderIds.includes(order.order_id));
        if (shouldFetch) {
            fetchOrders();
        }
    }, [])

    useEffect(() => {
        ordersRef.current = orders; // Always update ref when orders change
    }, [orders]);

    useEffect(() => {
        if (user?.role === 'customer') {
            fetchOrders()
            socket.on("orders_changed", handleOrdersListener);

            return () => {
                socket.off("orders_changed", handleOrdersListener);
            };
        }
    }, [user, userLoaded])

    useEffect(() => console.log(orders), [orders])


    return (
        <>
            <Grid2 container size={'grow'} justifyContent={'center'} sx={{
                backgroundImage: `url(${sierraBackground})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transform: 'scaleX(-1)'
            }}>
                <Grid2 sx={{ position: 'absolute', bottom: 0, right: 10, transform: 'scaleX(-1)' }}>
                    <Typography color='primary.dark'>v{version}</Typography>
                </Grid2>

                <Grid2 container size={'grow'} maxWidth={1600} flexDirection={'column'} height={'100vh'} sx={{ transform: 'scaleX(-1)' }}>

                    <Grid2 container size={'grow'} padding={2} spacing={2} flexDirection={'column'} >
                        <Grid2 container size={'auto'} display={'flex'} alignItems={'end'} overflow={'visible'} flexDirection={{ xs: 'column', md: 'row' }}>

                            <Grid2 container size='grow' width={{ xs: '100%', md: 'auto' }} alignItems={'end'}>
                                <Grid2 container justifyContent={'center'} paddingRight={2} sx={{ cursor: 'pointer' }} onClick={() => navigate('/')} height={{ xs: 60, md: 100 }}>
                                    <img src='/sierra-logo.png' style={{ height: '100%' }} />
                                </Grid2>

                                <Container padding={2} size={'grow'} overflow={undefined} height={'100%'}>
                                    <Typography variant="h5" fontWeight={'bold'} color="primary">
                                        {translate("Place Your Order")}
                                    </Typography>
                                </Container>
                            </Grid2>

                            <Grid2 container spacing={{ xs: 0, md: 2 }} size={'auto'} display={'flex'} width={{ xs: '100%', md: 'auto' }} justifyContent={{ xs: 'space-between', md: 'start' }}>

                                <Grid2 size={'auto'} display={!user || !orders || !userLoaded || user.role !== 'customer' ? 'none' : 'flex'}>
                                    <Badge sx={{ width: '100%', height: '100%' }} badgeContent={orders?.flatMap(obj => obj.order_details).filter(s => s.step_status === 'pending').length || 0} color="error">
                                        <Container size={'auto'} display={'flex'}>

                                            <Button sx={{ paddingX: 2, fontWeight: 'bold' }} endIcon={<FilterFrames />} onClick={() => navigate('/dashboard/orders')}>{translate("Track Orders")}</Button>

                                        </Container>
                                    </Badge>
                                </Grid2>

                                <Container padding={0.5} overflow={'visible'} size={'auto'} display={'flex'} alignItems={'center'}>
                                    {!userLoaded ? <CircularProgress /> : !user && userLoaded ? <Button onClick={() => navigate('/login')} sx={{ padding: 1.5 }} endIcon={<Login />}>{translate("Login")}</Button>
                                        : <IconButton onClick={() => {
                                            if (!user) return;
                                            if (user.role === 'customer') navigate('/dashboard')
                                            else navigate('/system')
                                        }}>
                                            <Person color="primary" fontSize={screenSize.xs ? 'medium' : 'large'} />
                                        </IconButton>
                                    }
                                </Container>

                                <Container overflow={'visible'} display={'flex'} alignItems={'center'} justifyContent={'center'} size={'auto'}>
                                    <LangDropdown />
                                </Container>
                            </Grid2>


                        </Grid2>

                        <Grid2 container size={'grow'}>
                            <Outlet />
                        </Grid2>

                    </Grid2>
                </Grid2>
            </Grid2>
            <ChatFab />
        </>
    )
})

export default Layout